// Centralized frontend configuration
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const CONFIG = {
  apiBaseUrl
};

export default CONFIG;